const toggleOpening = button => button.addEventListener('click', () => button.classList.toggle('is-active'))

export default toggleOpening